export interface DomainUsersTableRow {
  domain: string;
  userCount: number;
}

export enum PermissionTableOperation {
  Edit = 'Edit',
  View = 'View',
  None = 'None',
}

export enum PermissionTableModule {
  AddIntegration = 'ADD_INTEGRATION',
  RemoveIntegration = 'REMOVE_INTEGRATION',
  Metadata = 'METADATA',
  UnifyMetadata = 'UNIFY_METADATA',
  Taxonomy = 'TAXONOMY',
  Prediction = 'PREDICTION',
  Artefact = 'ARTEFACT',
  Template = 'TEMPLATE',
  CustomFilter = 'CUSTOM_FILTER',
  AllCustomFilter = 'ALL_CUSTOM_FILTER',
  WorkspaceSettings = 'WORKSPACE_SETTINGS',
  OutboundIntegration = 'OUTBOUND_INTEGRATION',
  QueryData = 'QUERY_DATA',
  Invite = 'INVITE',
}

export interface PermissionsTableRow {
  module: PermissionTableModule;
  adminOperation: PermissionTableOperation;
  editorOperation: PermissionTableOperation;
  memberOperation: PermissionTableOperation;
  viewerOperation: PermissionTableOperation;
}
